import { render, staticRenderFns } from "./KycTypeSelection.html?vue&type=template&id=d8bf31b2&scoped=true&"
import script from "./KycTypeSelection.js?vue&type=script&lang=js&"
export * from "./KycTypeSelection.js?vue&type=script&lang=js&"
import style0 from "./KycTypeSelection.scss?vue&type=style&index=0&id=d8bf31b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8bf31b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBadge,VBtn,VCard,VCol,VIcon,VRow})
